var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/sms-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-edit_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M9.33341 4H22.6667C26.6667 4 29.3334 6 29.3334 10.6667V14.8534C29.3334 15.8267 28.3334 16.44 27.4401 16.0533C25.9734 15.4133 24.3068 15.1733 22.5601 15.4533C19.0668 16.0267 16.2134 18.7867 15.5068 22.2533C15.3068 23.2667 15.2801 24.2533 15.4134 25.2C15.5201 25.9867 14.8801 26.68 14.0934 26.68H9.33341C5.33341 26.68 2.66675 24.68 2.66675 20.0133V10.68C2.66675 6.00001 5.33341 4 9.33341 4Z",
    fill: "#A39ED2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9999 15.8266C14.8799 15.8266 13.7465 15.48 12.8799 14.7733L8.70653 11.44C8.27987 11.0933 8.19987 10.4666 8.54654 10.04C8.8932 9.61331 9.51986 9.53332 9.94652 9.87999L14.1199 13.2133C15.1332 14.0267 16.8532 14.0267 17.8665 13.2133L22.0399 9.87999C22.4665 9.53332 23.1065 9.59998 23.4398 10.04C23.7865 10.4666 23.7199 11.1066 23.2799 11.44L19.1065 14.7733C18.2532 15.48 17.1199 15.8266 15.9999 15.8266Z",
    fill: "#A39ED2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.9999 17.3333C20.3199 17.3333 17.3333 20.3066 17.3333 24C17.3333 27.68 20.3199 30.6666 23.9999 30.6666C27.6933 30.6666 30.6666 27.68 30.6666 24C30.6666 20.3066 27.6933 17.3333 23.9999 17.3333ZM26.7332 23.4L26.2399 23.88L23.3466 26.7866C23.2133 26.9066 22.9599 27.04 22.7732 27.0666L21.4666 27.2533C20.9999 27.32 20.6666 26.9867 20.7332 26.52L20.9199 25.2133C20.9466 25.0267 21.0666 24.7733 21.1999 24.64L24.1066 21.7466L24.5866 21.2533C24.9066 20.9333 25.2666 20.72 25.6399 20.72C25.9599 20.72 26.3199 20.8666 26.7199 21.2533C27.5999 22.1333 27.3199 22.8133 26.7332 23.4Z",
    fill: "#A39ED2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMessage);
export default __webpack_public_path__ + "static/media/edit-message.7ff55b81822b912c1bcf634be15da62f.svg";
export { ForwardRef as ReactComponent };